import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { TopBar } from './components/TopBar';
import { ChatInterface } from './components/ChatInterface';
import { RiskPanel } from './components/RiskPanel';
import { RightSideNavBar } from './components/RightSideNavBar';
import { AIChat } from './components/AIChat';
export function App() {
  const [showRiskPanel, setShowRiskPanel] = useState(true);
  const [showAIChat, setShowAIChat] = useState(false);
  const [sendAutoMessage, setSendAutoMessage] = useState(false);
  const toggleRiskPanel = () => {
    setShowRiskPanel(!showRiskPanel);
  };
  const toggleAIChat = (autoMessage = false) => {
    setSendAutoMessage(autoMessage);
    setShowAIChat(!showAIChat);
  };
  return <div className="flex h-screen w-full bg-gray-50" data-id="element-0">
      <Sidebar data-id="element-1" />
      <div className="flex flex-col flex-1" data-id="element-2">
        <TopBar data-id="element-3" />
        <div className="flex flex-1 overflow-hidden" data-id="element-4">
          <ChatInterface data-id="element-5" />
          {showRiskPanel && <RiskPanel onClose={toggleRiskPanel} toggleAIChat={toggleAIChat} data-id="element-6" />}
          {showAIChat && <AIChat onClose={toggleAIChat} toggleRiskPanel={toggleRiskPanel} sendAutoMessage={sendAutoMessage} data-id="element-7" />}
          <RightSideNavBar toggleRiskPanel={toggleRiskPanel} showRiskPanel={showRiskPanel} toggleAIChat={toggleAIChat} showAIChat={showAIChat} data-id="element-8" />
        </div>
      </div>
    </div>;
}